module.exports = __webpack_public_path__ + "img/money_bg.c154a08b.png";